import React, {ReactNode} from "react";
import {Box, Colors, Text} from "@bounce/shared/ui";

export const INPUT_SX = {backgroundColor: Colors.bw.white, borderRadius: "8px"};

type FormCardProps = {
  title: string;
  hint?: string;
  children: ReactNode;
};

export const FormCard = ({title, hint, children}: FormCardProps) => (
  <Box
    sx={{
      width: "100%",
      backgroundColor: Colors.tertiary._100,
      borderRadius: "12px",
      padding: "20px",
      display: "flex",
      flexDirection: "column",
      gap: "16px",
    }}
  >
    <Box>
      <Text variant="interDisplay600" size={16} sx={{color: Colors.grey._800}}>
        {title}
      </Text>
      {hint && (
        <Text size={12} sx={{color: Colors.grey._600, mt: 0.5}}>
          {hint}
        </Text>
      )}
    </Box>
    {children}
  </Box>
);

type FieldLabelProps = {
  children: string;
  required?: boolean;
};

export const FieldLabel = ({children, required = false}: FieldLabelProps) => (
  <Text size={12} sx={{color: Colors.grey._700, mb: 0.5}}>
    {children} {required && <span style={{color: Colors.red._700}}>*</span>}
  </Text>
);
